/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";

export type V1DomainsCreateDomainRequestBody = {
  /**
   * Identifies a resource by either its unique ID or its slug.
   *
   * @remarks
   * Accepts a prefixed ID (such as 'proj_' or 'app_') or a slug.
   */
  project: string;
  /**
   * Identifies a resource by either its unique ID or its slug.
   *
   * @remarks
   * Accepts a prefixed ID (such as 'proj_' or 'app_') or a slug.
   */
  app: string;
  /**
   * Identifies a resource by either its unique ID or its slug.
   *
   * @remarks
   * Accepts a prefixed ID (such as 'proj_' or 'app_') or a slug.
   */
  environment: string;
  /**
   * Fully qualified domain name to attach to the environment, without a scheme, port, or path.
   *
   * @remarks
   * Must be unique across your entire workspace: the same name cannot be attached to two environments.
   *
   * The name must sit under a registrable domain: 'api.acme.co.uk' is accepted, the public suffix
   * 'co.uk' itself is not. Internationalized names may be sent in Unicode or Punycode form; either
   * way the domain is stored and returned in its canonical form, lowercase ASCII with Unicode labels
   * Punycode encoded, and the DNS records in the response use that form.
   */
  domain: string;
};

/** @internal */
export type V1DomainsCreateDomainRequestBody$Outbound = {
  project: string;
  app: string;
  environment: string;
  domain: string;
};

/** @internal */
export const V1DomainsCreateDomainRequestBody$outboundSchema: z.ZodType<
  V1DomainsCreateDomainRequestBody$Outbound,
  z.ZodTypeDef,
  V1DomainsCreateDomainRequestBody
> = z.object({
  project: z.string(),
  app: z.string(),
  environment: z.string(),
  domain: z.string(),
});

export function v1DomainsCreateDomainRequestBodyToJSON(
  v1DomainsCreateDomainRequestBody: V1DomainsCreateDomainRequestBody,
): string {
  return JSON.stringify(
    V1DomainsCreateDomainRequestBody$outboundSchema.parse(
      v1DomainsCreateDomainRequestBody,
    ),
  );
}
